import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { messages as m } from '../../../constants';
import * as D from '../../../deps';

class BackstagePodcastEpisodeSubheaderLarge extends React.Component {
  static propTypes = {
    programName: PropTypes.string,
    programUrl: PropTypes.string,
    isRemoved: PropTypes.bool,
  };

  static contextType = D.Utils.Context.AppContext;

  onHeaderLinkClick = e => {
    this.context.integration.action.clicked({
      contentSection: D.Constants.ContentSections.BackstageContentSections.HEADER,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  render() {
    if (!this.props.programName) {
      return null;
    } else if (this.props.isRemoved) {
      return (
        <div className='BackstagePodcastEpisodeSubheaderLarge'>
          <FormattedMessage {...m.by} /> {this.props.programName}
        </div>
      );
    }

    return (
      <div className='BackstagePodcastEpisodeSubheaderLarge'>
        <FormattedMessage {...m.by} />
        <Link
          className={D.HeaderBackstageStyles.SUBTITLE_LINK}
          to={this.props.programUrl}
          onClick={this.onHeaderLinkClick}
        >
          {this.props.programName}
        </Link>
      </div>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const { episodeId } = ownProps;
  const episodeAnnotation = D.getAnnotationsById(state, episodeId);

  const programId = D.Utils.Core.getFromMap(episodeAnnotation, 'podcastId');
  const programAnnotation = D.getAnnotationsById(state, programId);

  const programName = D.Utils.Core.getFromMap(episodeAnnotation, 'programName');
  const programUrl = D.Utils.Core.getFromMap(programAnnotation, 'shareableUrlPath');
  const isRemoved = D.Utils.Rights.isRemoved(programAnnotation);

  return {
    programName,
    programUrl,
    isRemoved,
  };
}

export default connect(mapStateToProps)(BackstagePodcastEpisodeSubheaderLarge);
